import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  ListSubheader,
} from '@mui/material';

import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import AppSidebarLayout from '@/components/shared/AppSidebarLayout';
import { Outlet, useLocation, useNavigate } from 'react-router';

function AccQsureAdmin(): React.JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  const app = location.pathname.split('/').at(-1);

  const NavMenuContent = (
    <>
      <List
        component='nav'
        subheader={
          <ListSubheader component='div' id='general-list-subheader'>
            General
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={app === 'tasks'}
          onClick={() => {
            navigate('/admin/accqsure/tasks');
          }}
        >
          <ListItemIcon>
            <CategoryOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Task Engine' />
        </ListItemButton>
        <ListItemButton
          selected={app === 'usage'}
          onClick={() => {
            navigate('/admin/accqsure/usage');
          }}
        >
          <ListItemIcon>
            <AnalyticsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='System Usage' />
        </ListItemButton>
        <ListItemButton
          selected={app === 'database'}
          onClick={() => {
            navigate('/admin/accqsure/database');
          }}
        >
          <ListItemIcon>
            <StorageOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Database Commands' />
        </ListItemButton>
        <ListItemButton
          selected={app === 'assets'}
          onClick={() => {
            navigate('/admin/accqsure/assets');
          }}
        >
          <ListItemIcon>
            <BugReportOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Asset Viewer' />
        </ListItemButton>
      </List>
    </>
  );

  return (
    <AppSidebarLayout
      headerTitle={'AccQsure Administration'}
      HeaderIcon={FactCheckOutlinedIcon}
      SidebarContent={NavMenuContent}
    >
      <Outlet />
    </AppSidebarLayout>
  );
}

export default AccQsureAdmin;
